// extracted by mini-css-extract-plugin
export default {"UploadingTasks":"UploadingTasks___C2ErO","title":"title___djdrd","successCount":"successCount___WpuC7","body":"body___UUnkK"};